import service from "@hybird/core/request";
import url from "@hybird/device/request";
import {BeginSealDeviceMethodInterceptor} from "@hybird/device/interceptor/beginSeal/core";
import {config} from "@hybird/device/config";
import {DeviceEvent} from "@hybird/core/device/protocol";

export class QrcodeBeginSealInterceptor extends BeginSealDeviceMethodInterceptor {

  /**
   *
   * @param params
   * @param proceed
   * @param self{DeviceProtocolBeginSeal}
   * @return {Promise<*>}
   */
  async equipmentLock(proceed, self, params = {}) {
    if (this.examineFinish === 1) {
      return proceed(params);
    }

    params.sendEquipmentLock = params.sendEquipmentLock ? params.sendEquipmentLock : async () => {
      const documentRemoteId = new Date().getTime() + "" + Math.floor(Math.random() * 10) + 1;

      self.deviceProtocol.emit(DeviceEvent.EQUIPMENT_LOCK, {documentRemoteId});

      return {
        documentRemoteId
      }
    }

    const result = await proceed(params);
    const documentRemoteId = result.documentRemoteId;

    const qrcodeUpload = async ({fileId}) => {
      return await service.post(url.qrcodeDiff, {
        documentId: self.deviceInfo.documentId,
        fileId: fileId,
        sealId: self.deviceInfo.sealId,
        address: config.address,
        gps: config.gps
      }).catch(async e => {
        // result.examineResult({documentRemoteId, state: 2});
        throw e;
      }).then(async data => {
        self.context.data.picture = [fileId];

        result.data = data;
        result.isSeal = 1;
        result.exec = async () => {
          await result.examineResult({documentRemoteId, state: 1});
        };

        return result;
      });
    };

    result.upload = result.upload ? result.upload.andThen(qrcodeUpload) : qrcodeUpload
    return result;
  }

  isSupport(self) {
    return self.option.sealAuthentication === 1 && self.deviceInfo.qrcodeType === 1 && self.deviceInfo.examineFinish !== 1;
  }
}
